module.exports = __webpack_public_path__ + "static/media/photo-2.941c373a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/willow-walk-remodelling/photo-2.jpg
// module id = 172
// module chunks = 0